import { _ as r } from "../_rollupPluginBabelHelpers-d2f9cf82.js";
import { useState as t, useEffect as e } from "react";
var o = function (o, n) {
  var u = t(o),
    a = r(u, 2),
    f = a[0],
    i = a[1];
  return e(function () {
    var r = setTimeout(function () {
      i(o);
    }, n);
    return function () {
      clearTimeout(r);
    };
  }, [o, n]), f;
};
export { o as default };